import { Spinner } from '@components/ui/Primitives'
import { AttachmentMalwareScanStatus } from '@query'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { useTheme } from 'styled-components'

export type AttachmentScanBlock = 'pending' | 'infected'

export function attachmentScanBlock(
  status: AttachmentMalwareScanStatus | undefined
): AttachmentScanBlock | null {
  switch (status) {
    case AttachmentMalwareScanStatus.PENDING:
      return 'pending'
    case AttachmentMalwareScanStatus.INFECTED:
      return 'infected'
    case AttachmentMalwareScanStatus.CLEAN:
    case AttachmentMalwareScanStatus.UNSCANNABLE:
    case AttachmentMalwareScanStatus.NOT_APPLICABLE:
    case undefined:
      return null
    default: {
      const exhaustive: never = status
      return exhaustive
    }
  }
}

interface Props {
  status?: AttachmentMalwareScanStatus
}

export const MalwareScanNotice: React.FC<Props> = ({ status }) => {
  const [t] = useTranslation()
  const theme = useTheme()
  const block = attachmentScanBlock(status)
  if (block === null) return null

  const label =
    block === 'pending' ? t('files.malwareScan.pending') : t('files.malwareScan.infected')

  return (
    <Notice>
      {block === 'pending' && <Spinner size={28} color={theme.colors.metalGray} />}
      <span>{label}</span>
    </Notice>
  )
}

const Notice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  padding: ${({ theme }) => theme.spacing.xxl}rem ${({ theme }) => theme.spacing.md}rem;
  background: ${({ theme }) => theme.colors.neutralGray};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  color: ${({ theme }) => theme.colors.metalGray};
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  text-align: center;
`
